import React, {useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import Chat from "./modules/chat";
import Video from "./modules/video";
import GroupChat from "./modules/group_chat";
import Hidden from './modules/hidden'
import Text from "./modules/text";
import classNames from "classnames";
import AjaxButton from "src/shared/form/ajax_button";
import _ from "lodash";
import Downloads from "./modules/downloads";
import Redirect from "./modules/redirect";
import ImageMapRedirect from "./modules/image_map_redirect";
import Iframe from './modules/iframe'
import InlineHtml from './modules/inline_html'
import SupportChat from "./modules/support_chat";
import SlideShow from "./modules/slideshow";
import DefaultHotspotSettings from "./modules/default_hotspot_settings";
import {clearHotspot, updateHotspot, applyHotspotChanges} from '../actions'
import LeadGeneration from "./modules/lead_generation";
import {serialize} from 'object-to-formdata'
import PdfViewer from './modules/pdf_viewer'
import AppointmentEditor from "./modules/appointment_editor";
import DirectMessagingEditorModule from "./modules/direct_messaging_editor_module";
import IframeEditorModule from "./modules/iframe_editor_module";
import ChatRouletteModule from "./modules/chat_roulette_module";

const getHotspotModule = (dispatch, hotspot) => {
  switch (hotspot.kind) {
    // key is important so the component gets rerendered for different hotspots
    case "chat":
      return <Chat key={hotspot.id}
                   initialState={hotspot.data.chatData}
                   onDataChanged={(data) => dispatch(updateHotspot({
                     ...hotspot,
                     data: {
                       ...hotspot.data,
                       chatData: data
                     }
                   }))}/>
    case "group_chat":
      return <GroupChat key={hotspot.id}
                        initialState={hotspot.data.groupChatData}
                        onDataChanged={(data) => dispatch(updateHotspot({
                          ...hotspot,
                          data: {
                            ...hotspot.data,
                            groupChatData: data
                          }
                        }))}
      />
    case "video":
      return <Video key={hotspot.id}
                    value={hotspot.data.video_url}
                    onDataChanged={(event) => {
                      dispatch(updateHotspot({
                        ...hotspot,
                        data: {
                          ...hotspot.data,
                          video_url: event.target.value
                        }
                      }))
                    }}
      />
    case "text":
      return <Text key={hotspot.id}
                   initialState={hotspot.data.textData}
                   onDataChanged={(data) => dispatch(updateHotspot({
                     ...hotspot,
                     data: {
                       ...hotspot.data,
                       textData: data
                     }
                   }))}
      />
    case "downloads":
      return <Downloads key={hotspot.id} hotspot={hotspot}/>
    case "pdf_viewer":
      return <PdfViewer key={hotspot.id} hotspot={hotspot}/>
    case "redirect":
      return <Redirect key={hotspot.id}
                       value={{
                         redirect_url: hotspot.data.redirect_url,
                         redirect_in_same_window: hotspot.data.redirect_in_same_window
                       }}
                       onDataChanged={(value) => {
                         dispatch(updateHotspot({
                           ...hotspot,
                           data: {
                             ...hotspot.data,
                             ...value
                           }
                         }))
                       }}
      />
    case "image_map_id":
      return <ImageMapRedirect key={hotspot.id}
                               value={hotspot.data.image_map_redirect_id}
                               onDataChanged={(event) => {
                                 dispatch(updateHotspot({
                                   ...hotspot,
                                   data: {
                                     ...hotspot.data,
                                     image_map_redirect_id: event.target.value
                                   }
                                 }))
                               }}/>
    case "iframe":
      return <Iframe key={hotspot.id}
                     value={hotspot.data.iframe_html}
                     onDataChanged={(value) => {
                       dispatch(updateHotspot({
                         ...hotspot,
                         data: {
                           ...hotspot.data,
                           iframe_html: value
                         }
                       }))
                     }}
      />
    case "inline_html":
      return <InlineHtml key={hotspot.id}
                     value={hotspot.data.inline_html}
                     onDataChanged={(value) => {
                       dispatch(updateHotspot({
                         ...hotspot,
                         data: {
                           ...hotspot.data,
                           inline_html: value
                         }
                       }))
                     }}
      />
    case "iframe_url":
      return <IframeEditorModule key={hotspot.id}
                                 value={hotspot.data.iframeData}
                                 onDataChanged={(data) => dispatch(updateHotspot({
                                   ...hotspot,
                                   data: {
                                     ...hotspot.data,
                                     iframeData: data
                                   }
                                 }))}
      />
    case "chat_roulette":
      return <ChatRouletteModule key={hotspot.id}
                                 value={hotspot.data.chatRouletteData}
                                 onDataChanged={(data) => dispatch(updateHotspot({
                                   ...hotspot,
                                   data: {
                                     ...hotspot.data,
                                     chatRouletteData: data
                                   }
                                 }))}
      />
    case "hidden":
      return <Hidden key={hotspot.id}/>
    case "support_chat":
      return <SupportChat key={hotspot.id}
                             initialState={hotspot.data.supportChatData}
                             onDataChanged={(data) => dispatch(updateHotspot({
                               ...hotspot,
                               data: {
                                 ...hotspot.data,
                                 supportChatData: data
                               }
                             }))}/>
    case "slideshow":
      return <SlideShow key={hotspot.id} hotspot={hotspot}/>
    case "appointment":
      return <AppointmentEditor key={hotspot.id} hotspot={hotspot}/>
    case "direct_messaging":
      return <DirectMessagingEditorModule key={hotspot.id}
                                          hotspot={hotspot}
                                          initialState={hotspot.data.directMessagingData}
                                          onDataChanged={(data) => dispatch(updateHotspot({
                                            ...hotspot,
                                            data: {
                                              ...hotspot.data,
                                              directMessagingData: data
                                            }
                                          }))}
      />
    case "lead_generation":
      return <LeadGeneration key={hotspot.id}
                             initialState={hotspot.data.leadGenerationData}
                             onDataChanged={(data) => dispatch(updateHotspot({
                               ...hotspot,
                               data: {
                                 ...hotspot.data,
                                 leadGenerationData: data
                               }
                             }))}/>
    case "contact":
      return null
    default:
      return <div>Unrecognized type.</div>
  }
}

export default function Editor(props) {
  const selectedHotspot = props.selectedHotspot

  const hotspotsUpdateUrl = useSelector((state) => state.hotspotsUpdateUrl)
  const hotspotUpdateData = useSelector((state) => state.hotspotUpdateData)
  const selectedHotspotId = useSelector((state) => state.selectedHotspotId)
  const hasUnsavedChanges = selectedHotspotId && !_.isEmpty(hotspotUpdateData)
  const account = useSelector((state) => state.account)
  const accountOrganization = useSelector((state) => state.accountOrganization)
  const imageHotspotConfig = useSelector(state => state.imageHotspotConfigs.find(imageHotspotConfig => imageHotspotConfig.id === selectedHotspot?.image_hotspot_config_id))
  const [editHotspotType, setEditHotspotType] = useState(false)
  const [currentHotspotType, setCurrentHotspotType] = useState("hidden")

  const dispatch = useDispatch()

  //const changeHotspotType = (hotspotType) => {
  //  setEditHotspotType(false)
  //  dispatch(updateHotspot({
  //    ...selectedHotspot,
  //    kind: hotspotType,
  //    data: selectedHotspot.data || {}
  //  }))
  //}

  // const typeRow = (name, title) => {
  //   return (
  //     <div className="form-check">
  //       <input type="radio" className="form-check-input" id={"hotspot_type" + selectedHotspot.id + name} name={"hotspot_type"} checked={selectedHotspot.kind == "text"} onChange={() => setCurrentHotspotType(name)}/>
  //       <label className="form-check-label" htmlFor={"hotspot_type" + selectedHotspot.id + name}>{title}</label>
  //     </div>
  //   )
  // }

  let editorContent = <div className="shadow p-4">
    <h5>No hotspot selected</h5>
    <p>
      First you have to select a hotspot, which can be done by simply clicking on one.
      <br/>
      <br/>
      After selecting a hotspot, settings will pop up here.
    </p>
  </div>

  console.debug({selectedHotspot, editorContent, hasUnsavedChanges})
  if (selectedHotspot) {
    editorContent = <div className="shadow pl-4 pr-4 pb-4 pt-2">
      {hasUnsavedChanges &&
      <div>
        <div className="row">
          <div className="col pb-1">
            <small className="text-muted">You have unsaved changes!</small>
          </div>
        </div>
        <div className="row">
          <div className="col-12 btn-group">
            <AjaxButton
              method="put"
              labelSending="Sending..."
              className={classNames("btn btn-outline-success btn-ueg")}
              icon="fa-save"
              url={hotspotsUpdateUrl}
              shortCut={"Ctrl+s"}
              data={() => {
                console.log("hotspotUpdateData", hotspotUpdateData)
                return serialize({hot_spots: hotspotUpdateData})
              }}
              label={"Save"}
              onSuccess={(data) => {
                if (data.status === 200) {
                  data.data.image_hotspots.map((ih) => {
                    dispatch(updateHotspot(ih))
                  })
                  dispatch(applyHotspotChanges())
                } else {
                  alert("Error updating hotspot")
                }
              }}
              onError={(error) => {
                console.log(error)
                alert("Error updating hotspot.", error)
              }}
            />
            <button className="btn btn-outline-danger btn-ueg ml-2" onClick={() => {
              dispatch(clearHotspot())
            }}>
              <i className="fa fa-times"></i>{" "}
              Cancel
            </button>
          </div>
        </div>
        <hr className="mb-0"/>
      </div>}

      <h5 className="hotspot-setting-header pt-2">Hotspot type</h5>
      <div className="hotspot-setting-info">
        By setting the hotspot type, you define what will be shown, when a user clicks the hotspot.
      </div>
      <select className="form-control"
              id="hotspotType"
              value={selectedHotspot.kind}
              onChange={(event) => {
                console.log(event.target.value)
                dispatch(updateHotspot({
                  ...selectedHotspot,
                  kind: event.target.value,
                  data: selectedHotspot?.data || {}
                }))
              }}>
        <option value="hidden">Hidden</option>
        {imageHotspotConfig.text_allowed && <option value="text">Text</option>}
        {imageHotspotConfig.video_allowed && <option value="video">Video Player</option>}
        {imageHotspotConfig.contact_allowed && <option value="contact">Contact</option>}
        {/*{imageHotspotConfig.group_chat_allowed &&<option value="group_chat">Group Chat</option>}*/}
        {imageHotspotConfig.downloads_allowed && <option value="downloads">Downloads</option>}
        {imageHotspotConfig.redirect_allowed && <option value="redirect">Redirect</option>}
        {imageHotspotConfig.image_map_allowed && <option value="image_map_id">Image Map</option>}
        {imageHotspotConfig.chat_allowed && <option value="chat">Video Chat</option>}
        {imageHotspotConfig.support_chat_allowed && <option value="support_chat">Text Chat</option>}
        {imageHotspotConfig.slideshow_allowed && <option value="slideshow">Slideshow</option>}
        {imageHotspotConfig.lead_generation_allowed && <option value="lead_generation">Lead Generation</option>}
        {imageHotspotConfig.pdf_viewer_allowed && <option value="pdf_viewer">PDF Viewer</option>}
        {imageHotspotConfig.appointment_allowed && <option value="appointment">Appointment</option>}
        {imageHotspotConfig.direct_messaging_allowed && <option value="direct_messaging">Direct Messaging</option>}
        {imageHotspotConfig.iframe_allowed && <option value="iframe_url">Iframe</option>}
        {imageHotspotConfig.chat_roulette_allowed && <option value="chat_roulette">Chat Roulette</option>}
        {account.backend_permission && imageHotspotConfig.raw_html_allowed && <option value="iframe">Raw HTML Popup</option>}
        {account.backend_permission && imageHotspotConfig.raw_html_allowed && <option value="inline_html">Inline HTML</option>}
      </select>

      {selectedHotspot.kind != "hidden" && <DefaultHotspotSettings hotspot={selectedHotspot}/>}

      {getHotspotModule(dispatch, selectedHotspot)}

    </div>
  }


  return (
    <div className="row no-gutters shadow mr-2 mr-md-4 ml-2 my-4">
      <div className="col-12">
        <div className="editor-header" ref={(node) => {
          if (node) {
            node.style.setProperty("background-color", accountOrganization.brand_color_1, "important");
            node.style.setProperty("color", accountOrganization.brand_color_2, "important");
          }
        }}>
          Editor
          {selectedHotspot &&
          <>{" "}
            for
            {" "}
            "{imageHotspotConfig.title}"
          </>
          }
        </div>
      </div>
      <div className="col-12">
        {editorContent}
      </div>
    </div>
  )
}
